import React from 'react';
import { confirmable, createConfirmation } from 'react-confirm';
import StyledComponent from 'styled-components';

const btnColor = '#e0e0e0';
const ContainerDiv = StyledComponent.div`
  .paper
  {
    background: rgb(255, 255, 255);
    border: 1px solid #000;
    box-shadow: rgba(0, 0, 0, 0.2) 0px 3px 5px -1px, rgba(0, 0, 0, 0.14) 0px 5px 8px 0px, rgba(0, 0, 0, 0.12) 0px 1px 14px 0px;
    padding: 8px 16px 12px;
    border-radius: 4px;
    z-index: 1;
  }
  p
  {
    color:      #2F2734;
    text-align: initial;
  }
  input[type=submit]
  {
    color:          rgba(0, 0, 0, 0.87) !important;
    background:     ${btnColor} !important;
    border-color:   ${btnColor} !important;
    padding:        8px 20px;
    border-radius:  4px;
    cursor:         pointer;
    margin-right:   10px;
    border-width:   0.5px;
    border-style:   solid;
    box-shadow:     0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12);
  }
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5;
  position: absolute;
  top: 25%;
  left: 40%;
`;

function Confirmation({
  proceedLabel,
  cancelLabel,
  confirmation,
  proceed,
}: {
  proceedLabel: string;
  cancelLabel: string;
  confirmation: string;
  proceed: (confirmed: boolean) => void;
}) {
  return (
    <ContainerDiv>
      <div className="paper">
        <p>{confirmation}</p>
        <input type="submit" onClick={() => proceed(false)} value={cancelLabel} />
        <input
          type="submit"
          className="button-l"
          onClick={() => proceed(true)}
          value={proceedLabel}
        />
      </div>
    </ContainerDiv>
  );
}

export function Confirm(
  confirmation: string,
  proceedLabel: string = 'Yes',
  cancelLabel = 'Cancel',
) {
  // @ts-ignore
  return createConfirmation(confirmable(Confirmation))({
    confirmation,
    proceedLabel,
    cancelLabel,
  });
}
